<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-awsBiz-replenishmentConfirm',
  components: { PageTable }
}
</script>
